const pages = {
  landings: [
    {
      title: 'DIF Municipal de Tuxtepec',
      href: '/dif-municipal-tuxtepec',
    },
    {
      title: 'Insituto Municipal de la mujer',
      href: '/instituto-municipal-de-la-mujer',
    },
    {
      title: 'Instituto Municipal de la juventud',
      href: '/imjut',
    },
    {
      title: 'Cabildo',
      href: '/cabildo',
    },
    {
      title: 'Organigrama del Ayuntamiento',
      href: '/organigrama',
    },
    {
      title: 'Actas de Cabildo',
      href: '/actas-de-cabildo',
    },
    {
      title: 'Directorio de funcionarios y dependencias',
      href: '/directorio-funcionarios-dependencias',
    },
    {
      title: 'Plan Municipal de Desarrollo',
      href: '/plan-municipal-desarrollo',
    },
    {
      title: 'Normateca',
      href: '/normateca',
    },
    {
      title: 'Transmisiones en Vivo ',
      href: '/transmisiones-vivo',
    },
    {
      title: 'Noticias',
      href: '/noticias',
    },

  ],
  company: [
    {
      title: 'Career Lising',
      href: '/career-listing',
    },
    {
      title: 'Job Opening',
      href: '/career-opening',
    },
    {
      title: 'Customer Stories',
      href: '/customers',
      isNew: true,
    },
    {
      title: 'Hire Us',
      href: '/hire-us',
      isNew: true,
    },
    {
      title: 'About: Startup',
      href: '/about-side-cover',
      isNew: true,
    },
    {
      title: 'About',
      href: '/about',
    },
    {
      title: 'Pricing',
      href: '/pricing',
    },
    {
      title: 'Terms',
      href: '/company-terms',
    },
    {
      title: 'Contact: Map',
      href: '/contact-sidebar-map',
    },
    {
      title: 'Contact: Minimal',
      href: '/contact-page-cover',
    },
    {
      title: 'Contact: Startup',
      href: '/contact-page',
    },
  ],
  account: [
    {
      title: 'General Settings',
      href: '/account-general',
    },
    {
      title: 'Security Settings',
      href: '/account-security',
    },
    {
      title: 'Notifications Options',
      href: '/account-notifications',
    },
    {
      title: 'Billing Options',
      href: '/account-billing',
    },
    {
      title: 'Sign up: Simple',
      href: '/signup-simple',
    },
    {
      title: 'Sign up: Cover',
      href: '/signup-cover',
    },
    {
      title: 'Sign in: Simple',
      href: '/signin-simple',
    },
    {
      title: 'Sign in: Cover',
      href: '/signin-cover',
    },
    {
      title: 'Password: Simple',
      href: '/password-reset-simple',
    },
    {
      title: 'Password: Cover',
      href: '/password-reset-cover',
    },
  ],
  secondary: [
    {
      title: 'Help Center: Overview',
      href: '/help-center',
    },
    {
      title: 'Help Center: Article',
      href: '/help-center-article',
    },
    {
      title: 'FAQ',
      href: '/faq',
      isNew: true,
    },
    {
      title: 'Error 404: Simple',
      href: '/not-found',
    },
    {
      title: 'Error 404: Cover',
      href: '/not-found-cover',
    },
    {
      title: 'Career Page Minimal',
      href: '/career-listing-minimal',
    },
  ],
  blog: [
    {
      title: 'Reach View',
      href: '/blog-reach-view',
    },
    {
      title: 'Search',
      href: '/blog-search',
    },
    {
      title: 'Newsroom',
      href: '/blog-newsroom',
    },
    {
      title: 'Article',
      href: '/blog-article',
    },
  ],
  portfolio: [
    {
      title: 'Grid View',
      href: '/portfolio-grid',
    },
    {
      title: 'Masonry',
      href: '/portfolio-masonry',
    },
    {
      title: 'Basic',
      href: '/portfolio-page',
    },
    {
      title: 'Parallax',
      href: '/agency',
    },
  ],
};

export default pages;
